export default __webpack_public_path__ + "static/media/eb-headphones-circled.621d8117.png";